import { getCookie } from "react-use-cookie";

export const isInternalUser = () => getCookie("grp-user") !== "external";
export const isAdminUser = () => getCookie("grp-user").includes("admin");
export const isReadershipUser = () => getCookie("grp-user").includes("readership");
export const isPublishUser = () => getCookie("grp-user").includes("publish");
